import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  myWalletVirtualCardDetailRouteProps,
  VirtualCardDetailMatchParams,
  virtualCardDetailRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectCreditCardListModelsFromState } from 'src/redux/selectors/data/creditCards.selectors'
import {
  selectVirtualCardPermissionsModelsFromState,
  selectVirtualCardSecureModels,
} from 'src/redux/selectors/data/virtualCards.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectVirtualCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<VirtualCardDetailMatchParams>(
      backgroundLocation.pathname,
      virtualCardDetailRouteProps,
    ) as match<VirtualCardDetailMatchParams>
    return mtch?.params.id
  },
)

export const selectMyWalletVirtualCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<VirtualCardDetailMatchParams>(
      backgroundLocation.pathname,
      myWalletVirtualCardDetailRouteProps,
    ) as match<VirtualCardDetailMatchParams>
    return mtch?.params?.id
  },
)

export const selectVirtualCard = createSelector(
  [selectVirtualCardSecureModels, selectVirtualCardIdFromRoute],
  (virtualCards, virtualCardId) => {
    return virtualCards[virtualCardId] !== undefined
      ? virtualCards[virtualCardId]
      : undefined
  },
)

export const selectMyWalletVirtualCard = createSelector(
  [selectVirtualCardSecureModels, selectMyWalletVirtualCardIdFromRoute],
  (virtualCards, virtualCardId) => {
    return virtualCards[virtualCardId] !== undefined
      ? virtualCards[virtualCardId]
      : undefined
  },
)

export const selectVirtualCardPermissions = createSelector(
  [selectVirtualCardPermissionsModelsFromState, selectVirtualCardIdFromRoute],
  (virtualCardPermissions, virtualCardId) => {
    return virtualCardPermissions[virtualCardId] !== undefined
      ? virtualCardPermissions[virtualCardId]
      : undefined
  },
)

export const selectMyWalletVirtualCardPermissions = createSelector(
  [selectVirtualCardPermissionsModelsFromState, selectMyWalletVirtualCardIdFromRoute],
  (virtualCardPermissions, virtualCardId) => {
    return virtualCardPermissions[virtualCardId] !== undefined
      ? virtualCardPermissions[virtualCardId]
      : undefined
  },
)

export const selectGetVirtualCardFailed = (state: RootState): boolean =>
  state.app.virtualCardDetail.getVirtualCardFailed

export const selectCreditCardListModelFromState = createSelector(
  [selectVirtualCard, selectCreditCardListModelsFromState],
  (vc, creditCards) =>
    Object.values(creditCards).filter((cc) => cc.id === vc?.creditCardId)[0],
)
